import React from 'react';
import { Stack, Typography } from '@mui/material';
import styles from './lable.module.scss';

interface FooterLabelProps {
  className?: string;
  title: React.ReactNode;
  titleClassName?: string;
  subtitle: React.ReactNode;
  subTitleClassName?: string;
}

const Label: React.FC<FooterLabelProps> = (props) => (
  <div className={`${styles.detailCard} ${props.className}`}>
    <Stack direction={'row'} alignItems={'center'} spacing={1}>
      {props.title && (
        <Typography
          variant='body2'
          component='h6'
          className={`${styles.title} ${props.titleClassName}`}
        >
          {props.title + ':'}
        </Typography>
      )}

      <Typography
        variant='subtitle2'
        component='h6'
        className={`${styles.subtitle} ${props.subTitleClassName}`}
      >
        {props.subtitle}
      </Typography>
    </Stack>
  </div>
);

export default Label;
